import styled from "@emotion/styled";
import * as React from "react";

import { ArrowReverse } from "@livechat/design-system-icons";
import {
  Button,
  Checkbox,
  DesignToken,
  Icon,
  RadiusToken,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import { StatusTag } from "components/status-tag/StatusTag";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { timeAgo } from "helpers/date";
import { ITicket } from "interfaces/entities/ticket";
import { textEllipsisStyles } from "styles/common";
import { withVar } from "themes/helpers";

interface ITicketOptionProps {
  ticket: ITicket;
  selectedChildTicketsIds: string[];
  hasCheckbox?: boolean;
  hasIcon?: boolean;
  setChildTickets: (ticketIds: string[]) => void;
}

const dateNow = new Date();

export const TicketOption: React.FC<ITicketOptionProps> = props => {
  const { selectedChildTicketsIds, ticket, setChildTickets, hasCheckbox, hasIcon } = props;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClick = (ticketId: string) => {
    if (selectedChildTicketsIds.find(item => item === ticketId)) {
      setChildTickets(selectedChildTicketsIds.filter(item => item !== ticketId));
    } else {
      setChildTickets([...selectedChildTicketsIds, ticketId]);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleLinkClick = () => {
    trackEngagement("Ticket: Merging tickets modal child ticket link click", EventPlace.Tickets);
  };

  return (
    <Wrapper>
      {hasCheckbox && (
        <div title={ticket.childTickets.length > 0 ? "You can't merge main tickets" : undefined}>
          <Checkbox
            data-testid={`merge-ticket-${ticket.id}-checkbox`}
            onClick={() => handleClick(ticket.id)}
            checked={selectedChildTicketsIds && !!selectedChildTicketsIds.find(item => item === ticket.id)}
            id={ticket.id}
            disabled={ticket.childTickets.length > 0}
          />
        </div>
      )}
      {hasIcon && (
        <Icon
          size="small"
          source={ArrowReverse}
          css={{
            transform: "rotate(-90deg)",
          }}
        />
      )}
      <StatusTag status={ticket.status} />
      <Button kind="link" target="_blank" href={`/tickets/${ticket.id}`} onClick={handleLinkClick}>
        <Text bold css={[{ maxWidth: "320px" }, textEllipsisStyles]}>
          {ticket.subject || "No subject"}
        </Text>
      </Button>
      <Text>{ticket.shortId}</Text>
      {ticket.updatedAt && <Text css={{ marginLeft: "auto" }}>{timeAgo(ticket.updatedAt, dateNow)}</Text>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: var(${SpacingToken.Spacing3}) var(${SpacingToken.Spacing4});
  border: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  box-sizing: border-box;
  border-radius: var(${RadiusToken.Radius3});
  margin-bottom: var(${SpacingToken.Spacing1});
  gap: var(${SpacingToken.Spacing2});

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    flex-wrap: wrap;
  }
`;
